import { Document } from "../Document/Document.type";
import { ApiCallState } from "../Utils";

export type User = {
  createdAt: string | number | Date;
  id: number;
  full_name: string;
  user_name: string;
  email: string;
  role: string;
  phone_number: string;
  company: Company;
  chat_id: string;
  signature: Signature | null;
  // access_type: string[];
  last_seen: any;
  user_role: {
    user_accesses: any;
    id: number;
    name: string;
  };
  is_super_user: any;
  // roles: string[];
  role_id: string;
  status: string;
  document_id?: number | null;
  document?: Document | null;
};

export type Company = {
  id: number;
  name: string;
  type: string;
  category: string;
  address: string;
  country: string;
};

export type Signature = {
  id: number;
  signature_url: string;
};

export type UserStateTypes = {
  fetchAll: ApiCallState<User[]>;
  fetchOne: ApiCallState<User | {}>;
  fetchLoggedIn: ApiCallState<User | {}>;
};

export const UserActionTypes = {
  FETCH_ALL_USER: "FETCH_ALL_USER",
  FETCH_ALL_USER_RESET: "FETCH_ALL_USER_RESET",
  FETCH_ALL_USER_FAILURE: "FETCH_ALL_USER_FAILURE",
  FETCH_ALL_USER_SUCCESS: "FETCH_ALL_USER_SUCCESS",

  FETCH_ONE_USER: "FETCH_ONE_USER",
  FETCH_ONE_USER_RESET: "FETCH_ONE_USER_RESET",
  FETCH_ONE_USER_FAILURE: "FETCH_ONE_USER_FAILURE",
  FETCH_ONE_USER_SUCCESS: "FETCH_ONE_USER_SUCCESS",

  FETCH_LOGGED_IN_USER: "FETCH_LOGGED_IN_USER",
  FETCH_LOGGED_IN_USER_RESET: "FETCH_LOGGED_IN_USER_RESET",
  FETCH_LOGGED_IN_USER_FAILURE: "FETCH_LOGGED_IN_USER_FAILURE",
  FETCH_LOGGED_IN_USER_SUCCESS: "FETCH_LOGGED_IN_USER_SUCCESS",

  FETCH_FEATURE_USER: "FETCH_FEATURE_USER",
  FETCH_FEATURE_USER_RESET: "FETCH_FEATURE_USER_RESET",
  FETCH_FEATURE_USER_FAILURE: "FETCH_FEATURE_USER_FAILURE",
  FETCH_FEATURE_USER_SUCCESS: "FETCH_FEATURE_USER_SUCCESS",

  LOGOUT_USER: "LOGOUT_USER",
};
